(function () {
  try {
    var root = document.documentElement;
    var inDesignMode = root.classList.contains('shopify-design-mode');
    var cfg = (typeof window !== 'undefined' && window.__KRAFTED_CONFIG) || {};
    var permanentDomain = typeof cfg.permanentDomain === 'string' ? cfg.permanentDomain : null;

    // Status setter with caching
    var cacheKey = 'krafted-status:' + (permanentDomain || 'unknown');
    function setStatus(status) {
      try {
        localStorage.setItem(cacheKey, status);
      } catch (e) {
        // ignore storage errors (private mode, quota, etc.)
      }
      root.setAttribute('data-krafted-status', status);
    }

    // Attempt to extract a store name from URLs that look like:
    // https://admin.shopify.com/store/<store-name>
    function getStoreNameFromUrl(url) {
      try {
        var u = new URL(url);
        var match = u.pathname.match(/\/?store\/([^\/?#]+)/);
        return match && match[1] ? decodeURIComponent(match[1]) : null;
      } catch (e) {
        return null;
      }
    }

    var candidates = [];
    // Current frame
    if (typeof window !== 'undefined' && window.location && window.location.href) {
      candidates.push(window.location.href);
    }
    // Referrer
    if (document && document.referrer) {
      candidates.push(document.referrer);
    }
    // Top frame (may be cross-origin; guard with try/catch)
    try {
      if (window.top && window.top.location && window.top.location.href) {
        candidates.push(window.top.location.href);
      }
    } catch (e) {
      // ignore cross-origin access errors
    }

    var detectedStoreName = null;
    for (var i = 0; i < candidates.length; i++) {
      var candidate = candidates[i];
      var name = getStoreNameFromUrl(candidate);
      if (name) {
        detectedStoreName = name;
        break;
      }
    }

    // Fallback: derive from permanent domain if available (e.g., lets-test-this-2.myshopify.com)
    if (!detectedStoreName && typeof permanentDomain === 'string' && permanentDomain.indexOf('.myshopify.com') > 0) {
      detectedStoreName = permanentDomain.split('.myshopify.com')[0];
    }

    // Additional fallback: use current hostname if it's a myshopify domain
    if (!detectedStoreName && window.location && typeof window.location.hostname === 'string') {
      var host = window.location.hostname;
      if (host.slice(-14) === '.myshopify.com') {
        var slug = host.slice(0, -14);
        if (slug) {
          detectedStoreName = slug;
        }
      }
    }

    if (detectedStoreName) {
      // Expose on the DOM for any other scripts
      root.setAttribute('data-krafted-store', detectedStoreName);
      // Apply cached status immediately (avoid layout shift later)
      try {
        var cached = localStorage.getItem(cacheKey);
        if (cached === 'active' || cached === 'inactive') {
          root.setAttribute('data-krafted-status', cached);
        }
      } catch (e) { }
      // Check against public endpoint of uninstalled stores (static API base)
      (async function checkUninstalled(name) {
        try {
          // Static endpoints (flip USE_LOCAL to true for local testing)
          var API_BASE_PROD = 'https://ai-store-launcher-app.onrender.com/api';
          var API_BASE_LOCAL = 'https://a80704248507.ngrok-free.app/api';
          var USE_LOCAL = false; // set to true for local testing
          var base = (USE_LOCAL ? API_BASE_LOCAL : API_BASE_PROD).replace(/\/$/, '') + '/public/uninstalled';
          var url = base + (base.indexOf('?') >= 0 ? '&' : '?') + 'storeName=' + encodeURIComponent(name);
          var resp = await fetch(url, { method: 'GET', credentials: 'omit', cache: 'no-store' });
          if (!resp.ok) throw new Error('HTTP ' + resp.status);
          var data = await resp.json();
          // Accept either { uninstalled: true } or bare true for flexibility
          var isUninstalled = (data && (data.uninstalled === true || data === true)) ? true : false;
          if (isUninstalled) {
            console.log('[Krafted AI] matched');
            setStatus('inactive');
          } else {
            console.log('[Krafted AI] not matched');
            setStatus('active');
          }
        } catch (e) {
          console.warn('[Krafted AI] Uninstalled check failed:', e && e.message ? e.message : e);
        }
      })(detectedStoreName);
    } else {
      console.warn('[Krafted AI] No store name detected from URL');
    }

    // After DOM is ready, check if the MainContent is currently hidden by the gate
    document.addEventListener(
      'DOMContentLoaded',
      function () {
        var main = document.getElementById('MainContent');
        if (!main) {
          console.warn('[Krafted AI] #MainContent not found');
          return;
        }
        var cs = window.getComputedStyle(main);
        var hidden = cs.display === 'none' || cs.visibility === 'hidden';
      },
      { once: true }
    );
  } catch (err) {
    console.error('[Krafted AI] security check error:', err);
  }
})();
